/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const Vue = require('vue');
const Vuex = require('vuex');

const common = require('src/common/vuex/module/common');
const appCommon = require('./module/common');
const login = require('./module/login');
const authorityBtn = require('./module/authorityBtn');
const detailsInfoImg = require('./module/topicInfoImgs');

Vue.use(Vuex);

module.exports = new Vuex.Store({
  modules: {
    common,
    appCommon,
    login,
    authorityBtn,
    detailsInfoImg
  }
})



// WEBPACK FOOTER //
// ./src/appBackend/vuex/store.js